import { BasicController, CommandController, EnvGlobalsHandler } from "@goodgamestudios/core";
import { BasicInitalizeControllerCommand } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { PokerGlobalData } from "../../model/components/PokerGlobalData";
import { Poker2WorldSelectionDialog } from "../../view/dialogs/Poker2WorldSelectionDialog";
import { Poker2WorldSelectionDialogProperties } from "../../view/dialogs/Poker2WorldSelectionDialogProperties";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";
import { Poker2SoundController } from "../Poker2SoundController";
import { Poker2EnvironmentGlobals } from "../../Poker2EnvironmentGlobals";

export class Poker2InitalizeControllerCommand extends BasicInitalizeControllerCommand {
    public execute(commandVars: any = null): void {
        super.execute();
        if (PokerGlobalData.instance.firstVisit == false) {
            if ((this.env.isTest || this.env.isLocal) && this.env.networkId > 1) {
                this.layoutManager.showDialog("Poker2WorldSelectionDialog", new Poker2WorldSelectionDialogProperties());
            }
        }
        PokerGlobalData.instance.firstVisit = false;
        //			layoutManager.onStartProgressbar();
        BasicController.getInstance().soundController = new Poker2SoundController();
        BasicController.getInstance().soundController.initialize();
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
    private get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}
classImplementsInterfaces(Poker2InitalizeControllerCommand, "ISimpleCommand");
